import { createContext, useContext, useState } from 'react';

const uploadedPlayersContext = createContext();

export const UploadedPlayersProvider = ({ children }) => {
    const [uploadedPlayers, setUploadedPlayers] = useState([])
  
    return (
      <uploadedPlayersContext.Provider value={{ uploadedPlayers, setUploadedPlayers }}>
        {children}
      </uploadedPlayersContext.Provider>
    )
  }
  
export const useUploadedPlayers = () => {
const { uploadedPlayers, setUploadedPlayers } = useContext(uploadedPlayersContext)
return { uploadedPlayers, setUploadedPlayers }
}